import { useMemo } from 'react';
import { DefaultTheme, useTheme } from 'styled-components';

import { Message, MessageOptions } from '@dreryk/react-components';

export enum HistoricalVisitStatus {
   NOT_APPROVED = 'NOT_APPROVED',
}

type HistoricalVisitsStatusProps = {
   readonly visitStatus: HistoricalVisitStatus;
};

const createHistoricalVisitsStatus = (theme: DefaultTheme): MessageOptions<typeof HistoricalVisitStatus> => ({
   [HistoricalVisitStatus.NOT_APPROVED]: {
      color: theme.error,
      backgroundColor: theme.errorLighter,
      labelColor: theme.errorDark,
   },
});

const useOptions = (): MessageOptions<typeof HistoricalVisitStatus> => {
   const theme = useTheme();
   return useMemo(() => createHistoricalVisitsStatus(theme), [theme]);
};

export const HistoricalVisitsStatus = (props: HistoricalVisitsStatusProps): JSX.Element => (
   <Message<typeof HistoricalVisitStatus>
      displayIndicator
      compact
      type={props.visitStatus}
      label='visit:appointments:statusCode:FINISHED_NOT_APPROVED'
      options={useOptions()}
      testId={'historicalVisitsStatus'}
   />
);
